"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.downloadFileForBrowser = downloadFileForBrowser;
exports.getFileForBrowserFromCache = getFileForBrowserFromCache;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _config = _interopRequireDefault(require("../../targets/cord_sanofi/config.js"));

var CACHE = {};

function arrayBufferToBase64(buffer) {
  var binary = '';
  var bytes = new Uint8Array(buffer);
  var len = bytes.byteLength;

  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return window.btoa(binary);
}

function downloadFileForBrowser(_x, _x2, _x3, _x4, _x5) {
  return _downloadFileForBrowser.apply(this, arguments);
}

function _downloadFileForBrowser() {
  _downloadFileForBrowser = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(remoteUrl, localFilename, md5, returnContent, onProgress) {
    var binaryAsB64,
        axiosConfig,
        response,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            binaryAsB64 = _args.length > 5 && _args[5] !== undefined ? _args[5] : false;
            console.log("downloading file from ".concat(remoteUrl, " to ").concat(localFilename));
            axiosConfig = {
              method: 'GET',
              url: remoteUrl,
              responseType: binaryAsB64 ? 'arraybuffer' : 'text',
              maxRedirects: 0,
              //    headers: {
              //      Authorization: `Basic ${window.btoa(`${target.defaultUser}:${target.defaultPassword}`)}`
              //    },
              withCredentials: true,
              auth: {
                username: _config["default"].defaultUser,
                password: _config["default"].defaultPassword
              }
            };
            _context.prev = 3;
            _context.next = 6;
            return (0, _axios["default"])(axiosConfig);

          case 6:
            response = _context.sent;
            _context.next = 13;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            console.error('axios error', _context.t0, axiosConfig);
            throw _context.t0;

          case 13:
            CACHE[localFilename] = binaryAsB64 ? arrayBufferToBase64(response.data) : response.data;
            return _context.abrupt("return", response.data);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));
  return _downloadFileForBrowser.apply(this, arguments);
}

function getFileForBrowserFromCache(localFilename) {
  return CACHE[localFilename];
}